"use client";

import { useState, useEffect } from "react";

export default function FooterYear() {
  const [year, setYear] = useState(2026);

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return (
    <p className="text-lg font-normal text-white">
      © {year} Basic Training. All rights reserved.
    </p>
  );
}
